import React from "react";
import Hsec1 from "../Componet/Hsec1";
import Hsec2 from "../Componet/Hsec2";
import Hsec3 from "../Componet/Hsec3";
import Hsec4 from "../Componet/Hsec4";
import Hsec5 from "../Componet/Hsec5";
import Hsec6 from "../Componet/Hsec6";
import Hsec7 from "../Componet/Hsec7";

const Home = () => {
  return (
    <div>
      <Hsec1 />
      <Hsec2 /> 
      <Hsec3 />
      <Hsec4 />
      <Hsec5 />
      <Hsec6 />
      <Hsec7 />
    </div>
  );
};

export default Home;
